<template>
  <div id="wrapper">
    <div id="content-wrapper">
      <div id="time_off_approval_fluid" class="container-fluid">
        <div class="time_off_approval">
          <div class="justify-content-start" style="height: 100%;">
            <!-- #region Employee Time-off Request Form -->
            <b-row
              class=""
              style="height:100%; background-color: #f4f7fc; padding: 0px; margin: 0px; border: 0px solid #ddd; border-radius: 0px 0px 5px 5px;"
            >
              <b-col cols="12" style="padding:0px; height:100%;">
                <b-card
                  body-class="body_card_custom"
                  class="ml-auto mr-auto"
                  style=""
                >
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col cols="12" style="padding:0px; float: left;">
                      <div
                        style="border: 0px; background: #fff; height: 140px; justify-content: center; align-items: center; display: flex;"
                      >
                        <template
                          v-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              is_sent_email_timeoff == sent_timeoff_stt.SENT
                          "
                        >
                          <img
                            id="timeoff_approved"
                            src="../assets/Email/approve_icon.png"
                            class="d-inline-block align-center"
                            alt="MeGroup"
                            width="100px"
                          />
                        </template>
                        <template
                          v-else-if="
                            (is_approval_timeoff_stt ==
                              approval_timeoff_stt.REQUESTING &&
                              is_sent_email_timeoff ==
                                sent_timeoff_stt.UNSEND) ||
                              (is_approval_timeoff_stt ==
                                approval_timeoff_stt.CONFIRMED &&
                                is_sent_email_timeoff ==
                                  sent_timeoff_stt.SENDING)
                          "
                        >
                          <img
                            id="timeoff_loading"
                            src="../assets/timeoff_loading.gif"
                            class="d-inline-block align-center"
                            alt="MeGroup"
                            width="100px"
                          />
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              (is_sent_email_timeoff ==
                                sent_timeoff_stt.UNSEND ||
                                is_sent_email_timeoff ==
                                  sent_timeoff_stt.SEND_ERROR)
                          "
                        >
                          <img
                            id="timeoff_sendmail_error"
                            src="../assets/Email/sendmail_error.png"
                            class="d-inline-block align-center"
                            alt="MeGroup"
                            width="100px"
                          />
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.APPROVAL_ERROR
                          "
                        >
                          <img
                            id="timeoff_error"
                            src="../assets/Email/timeoff_error.jpg"
                            class="d-inline-block align-center"
                            alt="MeGroup"
                            width="100px"
                          />
                        </template>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col cols="12" style="padding:0px; float: left;">
                      <p
                        style="min-height:45px; margin:3px; text-align:center; font-weight:700; font-size:30px; color:#666666; height:"
                      >
                        <template
                          v-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              (is_sent_email_timeoff == sent_timeoff_stt.SENT ||
                                is_sent_email_timeoff ==
                                  sent_timeoff_stt.UNSEND ||
                                is_sent_email_timeoff ==
                                  sent_timeoff_stt.SEND_ERROR)
                          "
                          >Thank You!
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.APPROVAL_ERROR
                          "
                          >Sorry!
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.REQUESTING &&
                              is_sent_email_timeoff == sent_timeoff_stt.UNSEND
                          "
                          >Loading!
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              is_sent_email_timeoff == sent_timeoff_stt.SENDING
                          "
                          >Sending mail!
                        </template>
                      </p>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 0px; margin: 0px;">
                    <b-col cols="12" style="padding:0px; float: left;">
                      <p
                        style="min-height: 45px; margin:3px 0 3px 12px; text-align:center; font-size:16px; color:#666666"
                      >
                        <template
                          v-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              is_sent_email_timeoff == sent_timeoff_stt.SENT
                          "
                          >Your submission has been sent.
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              is_sent_email_timeoff == sent_timeoff_stt.UNSEND
                          "
                        >
                          Your submission has been sent.
                          <span style="color:#ff0000;">
                            Mail has not been sent!!!
                          </span>
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              is_sent_email_timeoff == sent_timeoff_stt.SENDING
                          "
                        >
                          Your submission has been sent.
                          <span style="color:#06a730;">
                            Mail is being sent!!!
                          </span>
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.CONFIRMED &&
                              is_sent_email_timeoff ==
                                sent_timeoff_stt.SEND_ERROR
                          "
                        >
                          Your submission has been sent.
                          <span style="color:#ff0000;">
                            But there was an error sending the mail!!!
                          </span>
                        </template>
                        <template
                          v-else-if="
                            is_approval_timeoff_stt ==
                              approval_timeoff_stt.APPROVAL_ERROR
                          "
                        >
                          <span style="color:#ff0000;">
                            An error occurred. {{ res_message }}
                          </span>
                        </template>
                      </p>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <!--#endregion -->
          </div>
        </div>

        <!-- <b-card body-class="card_body_custom" style="margin: auto; width: 40%;">
          <div
            style="text-align: center; margin: 15px 0px 5px 0px; height: 150px;"
          >
            <img
              :src="change_confirm_logo(this.confirm)"
              height="150px"
              style=""
            />
          </div>
          <div
            style="text-align: center; font-weight: 700; font-size: 25px; color: #666666;"
          >
            <span
              v-if="
                this.confirm.toLowerCase() == 'approve' ||
                  this.confirm.toLowerCase() == 'decline'
              "
              style="color : #1f1e1e;"
              >SUCCESSFUL</span
            >
            <span
              v-if="this.confirm.toLowerCase() == 'bad request'"
              style="color : #1f1e1e;"
              >NOT FOUND</span
            >
          </div>
          <div
            style="text-align: center; font-weight: 700; font-size: 14px; color: #666666; margin: 10px 0px 5px 0px;"
          >
            <span
              v-if="
                this.confirm.toLowerCase() == 'approve' ||
                  this.confirm.toLowerCase() == 'decline'
              "
              >You have
              {{
                this.confirm.toLowerCase() == "approve"
                  ? "approved"
                  : this.confirm.toLowerCase() == "decline"
                  ? "decline"
                  : ""
              }}
              the Time-off Request</span
            >
            <span v-if="this.confirm.toLowerCase() == 'bad request'"
              >Time-off confirmed or not found</span
            >
          </div> -->
        <!-- <b-form @submit.prevent="submitLeave" autocomplete="off"> </b-form> -->
        <!-- </b-card> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ConfirmApproval",
  // components: {},
  // props: {},
  data() {
    return {
      leaveschedules_list: [],

      // approval_timeoff_stt: {
      //   NOT_APPROVED_YET: -1,
      //   REQUESTING: 0,
      //   AWATING_APPROVAL: 1, //trangthaiduyet = 0
      //   APPROVED: 2, //trangthaiduyet = 1
      //   DECLINED: 3, //trangthaiduyet = 2
      //   APPROVAL_ERROR: 4,
      // },
      approval_timeoff_stt: {
        NOT_APPROVED_YET: -1,
        REQUESTING: 0,
        CONFIRMED: 1,
        APPROVAL_ERROR: 2,
      },
      sent_timeoff_stt: {
        UNSEND: -1,
        SENDING: 0,
        SENT: 1,
        SEND_ERROR: 2,
      },

      is_approval_timeoff_stt: -1,
      is_sent_email_timeoff: -1,

      res_message: "Oops!!!",
      // confirm: "",
      authorization_token:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9." +
        "eyJzdWIiOiJBZG1pbiIsImp0aSI6ImE1ZGQxMzU2LWM0YTctNGE0Mi04YWI0LWQ3NmUxN2E5M2Q1ZCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWVpZGVudGlmaWVyIjoiQWRt" +
        "aW4iLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiQWRtaW4iLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIy" +
        "IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvZW1haWxhZGRyZXNzIjoiYWRtaW5AZ21haWwuY29tIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50" +
        "aXR5L2NsYWltcy9yb2xlIjpbInRhc2tfcmVhZCIsInRhc2tfcmVhZGFsbCIsInRhc2tfY3JlYXRlIiwidGFza191cGRhdGUiLCJ0YXNrX2RlbGV0ZSIsImhvc29fcmVhZCIsImhvc29fY3JlYXRlIiwiaG9zb191cGRhdGUiLCJob3NvX2Rl" +
        "bGV0ZSIsImNvbmd0eV9yZWFkYWxsIiwiaG9zb19yZXBvcnQiLCJtZWV0aW5nX3JlYWQiLCJtZWV0aW5nX2NyZWF0ZSIsIm1lZXRpbmdfdXBkYXRlIiwibWVldGluZ19kZWxldGUiLCJtZWV0aW5nZXZlbnRfcmVhZCIsIm1lZXRpbmdldmVu" +
        "dF9jcmVhdGUiLCJtZWV0aW5nZXZlbnRfdXBkYXRlIiwibWVldGluZ2V2ZW50X2RlbGV0ZSIsIm1lZXRpbmdldmVudF9kdXlldCIsInByb2ZpdF9hbmRfbG9zcyIsImxlYXZlc2NoZWR1bGVfcmVhZCIsImFzc2V0X3JlYWQiLCJzeXN0ZW1f" +
        "cmVhZCIsImN1c3RvbWVyY29udHJhY3RfcmVhZCIsImhvc29faGRsZF9yZWFkIiwiaG9zb19oZGxkX2N1ZCIsImhvc29fcmVwb3J0MSIsImhvc29fcmVwb3J0MiIsImhvc29fcmVwb3J0MyIsImhvc29fcmVwb3J0NCIsImhvc29fcmVwb3J0" +
        "NSIsImhvc29fcmVwb3J0NiIsImhvc29fcmVwb3J0NyIsImhvc29fcmVwb3J0OCIsImhvc29fcmVwb3J0OSIsImhvc29fcmVwb3J0MTAiLCJob3NvX3JlcG9ydF9hbGwiLCJkZXBhcnRtZW50X3JlYWQiLCJkZXBhcnRtZW50X2NyZWF0ZSIs" +
        "ImRlcGFydG1lbnRfdXBkYXRlIiwiZGVwYXJ0bWVudF9kZWxldGUiLCJraGVudGh1b25nX3JlYWQiLCJraGVudGh1b25nX2N1ZCIsImt5bHVhdF9yZWFkIiwia3lsdWF0X2N1ZCIsImRhb3Rhb19yZWFkIiwiZGFvdGFvX2N1ZCIsImJhbmdj" +
        "YXBfcmVhZCIsImJhbmdjYXBfY3VkIiwidGFpbGlldV9yZWFkIiwidGFpbGlldV9jdWQiLCJhc3NldF9jdWQiLCJhc3NldF90eXBlX3JjdWQiLCJhc3NldF9yb29tX3JjdWQiLCJhc3NldF9yZXBvcnRfcmVhZCIsImRhc2hib2FyZF9yZWFk" +
        "IiwicHJvamVjdF9jb250cmFjdF9yZWFkIiwicHJvamVjdF9jdXN0b21lcl9yZWFkIiwicHJvamVjdF9ib251c19yZWFkIiwicHJvamVjdF9yZXBvcnQiLCJwcm9qZWN0X3JlcG9ydDEiLCJwcm9qZWN0X3JlcG9ydF9hbGwiLCJzYWxhcnlf" +
        "cmVhZCIsImhvc29fcmVwb3J0MTEiLCJwcm9qZWN0X3JlcG9ydDIiLCJwcm9qZWN0X3JlcG9ydDMiLCJwcm9qZWN0X3JlcG9ydDQiLCJwcm9qZWN0X3JlcG9ydDUiLCJsZWF2ZXNjaGVkdWxlX3JlcG9ydCIsImhvdXNlX3JlYWQiLCJxdGFr" +
        "ZV9jcmVhdGUiLCJxdGFrZV91cGRhdGUiLCJxdGFrZV9kZWxldGUiLCJxdGFrZV9kdXlldCIsInF0YWtlX3JlYWQiLCJxdGFrZV9wcmljZSIsInF0YWtlX3Byb2plY3QiLCJxdGFrZV9jb3N0IiwicXRha2VfcmVwb3J0IiwiYXNzZXRfZGVs" +
        "ZXRlIiwicHJvZHVjdGlvbl9yZWFkYWxsIiwicHJvZHVjdGlvbl9yZWFkIiwicHJvZHVjdGlvbl9jcmVhdGUiLCJwcm9kdWN0aW9uX3VwZGF0ZSIsInByb2R1Y3Rpb25fZGVsZXRlIiwiaG9zb19pc1N5c0FjYyJdLCJEZXBhcnRtZW50SWQi" +
        "OiIwIiwiZXhwIjoxNjYxMzQ3NzAyLCJpc3MiOiJNZUdyb3VwQXBpIiwiYXVkIjoiTWVHcm91cFdlYkFwcCJ9.CfvnwUjyocabEWFqDy7Rv5L3Qpqsx1ZKzfFgR1YDA8s",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) =>
      vm.initData(to.params.id, to.params.confirm, to.params.line_manager_id)
    );
  },
  methods: {
    initData(leave_schedule_id, confirm, line_manager_id) {
      this.is_approval_timeoff_stt = this.approval_timeoff_stt.NOT_APPROVED_YET;
      this.is_sent_email_timeoff = this.sent_timeoff_stt.UNSEND;

      // if (confirm.toLowerCase() == "approve")
      this.ConfirmTimeOffRequest(
        leave_schedule_id,
        confirm.toLowerCase(),
        line_manager_id
      );
      // else if (confirm.toLowerCase() == "decline")
      //   this.declineItem(leave_schedule_id, confirm, line_manager_id);
    },

    ConfirmTimeOffRequest(leave_schedule_id, confirm, line_manager_id) {
      this.is_approval_timeoff_stt = this.approval_timeoff_stt.REQUESTING;
      const headers = {
        Authorization: this.authorization_token,
      };
      axios
        .put(
          `/api/timeoffrequest/${leave_schedule_id}/${line_manager_id}/${confirm}`,
          "",
          { headers }
        )
        .then((res) => {
          // this.confirm = confirm;
          this.is_approval_timeoff_stt = this.approval_timeoff_stt.CONFIRMED;
          this.is_sent_email_timeoff = this.sent_timeoff_stt.SENDING;
          // this.$toast.success(`${confirm.charAt(0).toUpperCase() + confirm.slice(1)} successfully!`,
          //   "Success",
          //   {timeout: 10000,}
          // );
          const emailForm = res.data.emailArr;
          axios
            .post("/api/timeoffrequest/sendmail2", emailForm, { headers })
            .then((res) => {
              this.is_sent_email_timeoff = this.sent_timeoff_stt.SENT;
              // this.$toast.success(
              //   "Time-off Request has been successfully emailed!",
              //   "Success",
              //   {
              //     timeout: 10000,
              //   }
              // );
            })
            .catch((err) => {
              // this.confirm = "bad request";
              this.res_message = err.response.data;
              this.is_sent_email_timeoff = this.sent_timeoff_stt.SEND_ERROR;

              // this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        })
        .catch((err) => {
          // this.confirm = "bad request";
          this.res_message = err.response.data;
          this.is_approval_timeoff_stt = this.approval_timeoff_stt.APPROVAL_ERROR;
          // this.$toast.error(err.response.data, "Error", { timeout: 10000 });
        });
    },
    // declineItem(leave_schedule_id, confirm, line_manager_id) {
    //   const headers = {
    //     Authorization: this.authorization_token,
    //   };
    //   axios
    //     .put(
    //       `/api/timeoffrequest/${leave_schedule_id}/${line_manager_id}/decline`,
    //       "",
    //       { headers }
    //     )
    //     .then((res) => {
    //       this.confirm = confirm;
    //       this.$toast.success("Decline successfully!", "Success", {
    //         timeout: 10000,
    //       });
    //       const emailForm = res.data.emailArr;
    //       axios
    //         .post("/api/timeoffrequest/sendmail2", emailForm, { headers })
    //         .then((res) => {
    //           this.$toast.success(
    //             "Time-off Request has been successfully emailed!",
    //             "Success",
    //             {
    //               timeout: 10000,
    //             }
    //           );
    //         })
    //         .catch((err) => {
    //           this.confirm = "bad request";
    //           this.$toast.error(err.response.data, "Error", { timeout: 3000 });
    //         });
    //     })
    //     .catch((err) => {
    //       this.confirm = "bad request";
    //       this.$toast.error(err.response.data, "Error", { timeout: 10000 });
    //     });
    // },

    // change_confirm_logo(confirm) {
    //   var url_icon = "";
    //   if (
    //     confirm.toLowerCase() == "approve" ||
    //     confirm.toLowerCase() == "decline"
    //   ) {
    //     url_icon = require("../assets/Email/approve_icon.png");
    //   } else if (confirm.toLowerCase() == "") {
    //     url_icon = require("../assets/loading.gif");
    //   }
    //   return url_icon;
    // },
  },
};
</script>

<style scoped></style>
<style>
#timeoff_loading_modal .modal-dialog {
  min-width: 214px;
}

#timeoff_loading_modal .btn-timeoff-confirm {
  color: #fff;
  border-radius: 4px;
  background: #0ebf00;
  text-decoration: none;
  transition: all 0.4s;
  line-height: 1.5;
  border: none;
  width: calc(100% - 100px);
  width: -webkit-calc(100% - 100px);
  width: -moz-calc(100% - 100px);
}

#timeoff_loading_modal .btn-timeoff-confirm:hover {
  background: #0a8300;
  outline: none;
}

#timeoff_loading_modal .btn-timeoff-confirm:active {
  color: #fff;
  background-color: #075f00;
  border-color: #075f00;
}

#timeoff_loading_modal .btn-timeoff-confirm-error {
  color: #fff;
  border-radius: 4px;
  background: #fb4d4d;
  text-decoration: none;
  transition: all 0.4s;
  line-height: 1.5;
  border: none;
  width: calc(100% - 100px);
  width: -webkit-calc(100% - 100px);
  width: -moz-calc(100% - 100px);
}

#timeoff_loading_modal .btn-timeoff-confirm-error:hover {
  background: #f93939;
  outline: none;
}

#timeoff_loading_modal .btn-timeoff-confirm-error:active {
  color: #fff;
  background-color: #b73838;
  border-color: #b73838;
}

#time_off_approval_fluid #master_datepicker__value_ {
  font-size: 0px;
}

#time_off_approval_fluid .time_off_approval {
  padding: 0px;
  margin: auto;
  color: #000;
  border-radius: 10px;
  background-color: #f4f7fc;
  width: min(100%, 782px);
}

#time_off_approval_fluid.container-fluid {
  height: calc(100%);
  display: flex;
  overflow: auto;
}

#time_off_approval_fluid .card {
  width: min(100%, 500px);
  min-width: 200px;
  border: 0px solid #ddd;
  border-radius: 5px;
}

#time_off_approval_fluid .body_card_custom {
  padding: 15px;
}

#time_off_approval_fluid .form-control-sm,
.custom-select:disabled,
textarea.form-control {
  font-size: 1rem;
}

/*#region Time-off Request Form*/
#time_off_approval_fluid #department_tio_req_form {
  flex: 0 0 calc(100% - 180px);
  max-width: calc(100% - 180px);
}

#time_off_approval_fluid #remain_tio_req_form {
  flex: 0 0 180px;
  max-width: 180px;
}
/*#endregion Time-off Request Form*/

@media (max-width: 500px) {
  #time_off_approval_fluid #department_tio_req_form,
  #time_off_approval_fluid #remain_tio_req_form,
  #time_off_approval_fluid #fromdate_tio_req_form,
  #time_off_approval_fluid #todate_tio_req_form {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0px;
  }

  #time_off_approval_fluid #fullname_tio_req_form,
  #time_off_approval_fluid #linemanager_tio_req_form,
  #time_off_approval_fluid #type_tio_req_form,
  #time_off_approval_fluid #reasons_tio_req_form {
    padding: 0px;
  }
}
/*#region Scrollbar*/
#time_off_approval_fluid::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(109, 118, 126, 0.8);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#time_off_approval_fluid::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

#time_off_approval_fluid::-webkit-scrollbar:horizontal {
  height: 13px;
  background-color: #f5f5f5;
}

#time_off_approval_fluid::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: hsl(0deg 0% 66%);
}

#time_off_approval_fluid::-webkit-scrollbar-thumb:hover {
  box-shadow: inset 0 0 6px rgba(52, 58, 64, 1);
}
/*#endregion Scrollbar*/
</style>
